import type { BreadcrumbSegment } from '../../contexts/breadcrumb-context';
import type { Competition } from '../../types/competition';

type CrumbCompetition = Pick<Competition, 'name' | 'logo_small_url' | 'trophy'>;

/** The stage's own logo, or else its circuit's. */
export function competitionLogo(competition: CrumbCompetition | null | undefined): string | null {
  return competition?.logo_small_url || competition?.trophy?.logo_small_url || null;
}

/**
 * The first step of the navbar on a page below a competition — a round, a
 * block, an athlete's card: the stage's logo (or its circuit's) **in place of
 * DivePeaks'**, leading back to the stage. Without a logo the trail is left as
 * it was, with the app's own logo first.
 */
export function competitionCrumb(
  competition: CrumbCompetition | null | undefined,
  onClick: () => void
): { hideHomeLogo: boolean; segments: BreadcrumbSegment[] } {
  const logo = competitionLogo(competition);
  if (!competition || !logo) return { hideHomeLogo: false, segments: [] };
  return {
    hideHomeLogo: true,
    segments: [{ label: competition.name, avatarUrl: logo, onClick }],
  };
}
